export class TabConstants {
    public static MEMBER_EMAIL = 'member-email';
    public static ORDER_HISTORY = 'order-history';
    public static ORDER_PROMOTION = 'order-promotion';
    public static CUSTOMER_TICKET = 'customer-ticket';
    public static MY_TEAM_TICKETS = 'my-team-tickets';
    public static MY_TICKETS = 'my-tickets';
    public static FORM_TICKETS = 'form-tickets';
    public static DEPARTMENT = 'department';
    public static CUSTOMER_SEARCH = 'customer-search';
    public static DEPARTMENT_USER_SEARCH = 'department-user-search';
    public static LEFT_ARROW_TAB = 'left-arrow-tab';
    public static RIGHT_ARROW_TAB = 'right-arrow-tab';
    public static FD_TICKETS = 'fd-tickets';
  }



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/tab.constants.ts